import { PayrollStatus } from "./enums";

// What the signed-in user can do with a payroll (computed by the API).
export interface PayrollActions {
    canAdvance: boolean;
    advanceLabel?: string;
    canReturnToHR: boolean;
    canReturnToFinance: boolean;
    canRollBack: boolean;
    waitingFor: string;
}

export interface PayrollApprovalEntry {
    id: number;
    action: string;
    fromStatus: PayrollStatus;
    toStatus: PayrollStatus;
    remarks?: string;
    by?: string;
    at: string;
}

export interface PayrollApprovalsVM {
    id: number;
    branch?: string;
    forMonth: string;
    status: PayrollStatus;
    initiatedBy?: string;
    initiatedAt: string;
    actions: PayrollActions;
    history: PayrollApprovalEntry[];
}

export interface PayrollAwaitingVM {
    id: number;
    branch?: string;
    forMonth: string;
    status: PayrollStatus;
    waitingFor: string;
}

// The approval chain in order. A payroll has completed every step up to and including its status.
export const PAYROLL_STEPS: { status: PayrollStatus; title: string; role: string }[] = [
    { status: PayrollStatus.Pending, title: "Initiated", role: "HR" },
    { status: PayrollStatus.CheckedByDirectorOfAdmin, title: "Checked", role: "Director of Admin" },
    { status: PayrollStatus.ApprovedByFinance, title: "Approved", role: "Head of Finance" },
    { status: PayrollStatus.ApprovedByDirectorOfAdmin, title: "Approved", role: "Director of Admin" },
    { status: PayrollStatus.ApprovedBySecretaryGeneral, title: "Approved", role: "Secretary General" },
    { status: PayrollStatus.Approved, title: "Approved", role: "Mayor" },
];

// Number of steps completed (returned payrolls are back at the start, with HR).
export const payrollStepsDone = (status: PayrollStatus) =>
    status === PayrollStatus.ReturnedToHR ? 0 : PAYROLL_STEPS.findIndex((s) => s.status === status) + 1;

export const PAYROLL_STATUS_LABELS: Record<PayrollStatus, string> = {
    [PayrollStatus.Pending]: "Awaiting Director of Admin check",
    [PayrollStatus.CheckedByDirectorOfAdmin]: "Awaiting Head of Finance",
    [PayrollStatus.ApprovedByFinance]: "Awaiting Director of Admin approval",
    [PayrollStatus.ApprovedByDirectorOfAdmin]: "Awaiting Secretary General",
    [PayrollStatus.ApprovedBySecretaryGeneral]: "Awaiting Mayor",
    [PayrollStatus.Approved]: "Approved",
    [PayrollStatus.ReturnedToHR]: "Returned to HR",
};

export const payrollStatusTone = (status: PayrollStatus) =>
    status === PayrollStatus.Approved ? "success" : status === PayrollStatus.ReturnedToHR ? "danger" : "warning";
